<template>
    <div class="Submenu hidden-sm hidden-xs">
        <ul class="Utility__list-unstyled">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
    export default {

    }
</script>